import { render } from "./live-text.vue?vue&type=template&id=a7930654"
import script from "./live-text.vue?vue&type=script&lang=js"
export * from "./live-text.vue?vue&type=script&lang=js"

import "./live-text.vue?vue&type=style&index=0&id=a7930654&lang=scss"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__